import { LOGISTICS_STAGE_KEYS, getLogisticsStageConfig } from "./logisticsStages";

export const LOGISTICS_STATUS_OPTIONS = [
  
  { value: "COMPLETED", label: "Completed" },

  {/* { value: "ON_HOLD", label: "On Hold" },
      { value: "NOT_STARTED", label: "Not Started" },
      { value: "IN_PROGRESS", label: "In Progress" }, 
  */},
 
];

// nextAction is what a card shows, so it is kept short. The design reviews use their acronyms:
// IDR (issued for internal review), ICR (issued for client review), IFC (issued for construction).
export const LOGISTICS_MILESTONE_OPTIONS = {
  "DESIGN & ENGINEERING": [
    {
      value: "Issued for Internal Review",
      label: "Issued for Internal Review",
      progressPercent: 25,
      nextAction: "Issue ICR",
    },
    {
      value: "Issued for Client Review",
      label: "Issued for Client Review",
      progressPercent: 50,
      nextAction: "Issue IFC",
    },
    {
      value: "Issued for Construction",
      label: "Issued for Construction",
      progressPercent: 75,
      nextAction: "Capture As Built",
    },
    {
      value: "AS Built",
      label: "AS Built",
      progressPercent: 100,
      nextAction: "Start Procurement",
    },
  ],
  PROCUREMENT: [
    {
      value: "Supplier-Name",
      label: "Supplier Name",
      progressPercent: 25,
      nextAction: "Place Purchase Order",
      detail: {
        type: "text",
        field: "detailText",
        label: "Supplier Name",
      },
    },
    {
      value: "PO Placed",
      label: "PO Placed",
      progressPercent: 75,
      nextAction: "Await Delivery",
    },
    {
      value: "Delivered(date)",
      label: "Delivered",
      progressPercent: 100,
      nextAction: "Start Manufacturing",
      detail: {
        type: "date",
        field: "detailDate",
        label: "Delivered Date",
        dateRule: "pastOrToday",
        displayLabel: "Delivered",
      },
    },
  ],
  "MANUFACTURING & FABRICATION": [
    {
      value: "Started",
      label: "Started",
      progressPercent: 25,
      nextAction: "Complete FAT",
    },
    {
      value: "FAT Complete",
      label: "FAT Complete",
      progressPercent: 50,
      nextAction: "Confirm Expected Delivery",
    },
    {
      value: "Expected Delivery Date",
      label: "Expected Delivery Date",
      progressPercent: 75,
      nextAction: "Await Delivery",
      detail: {
        type: "date",
        field: "detailDate",
        label: "Expected Delivery Date",
        dateRule: "todayOrFuture",
        displayLabel: "Expected Delivery",
      },
    },
    {
      value: "Actual Delivery Date",
      label: "Actual Delivery Date",
      progressPercent: 100,
      nextAction: "Appoint Installer/Contractor",
      detail: {
        type: "date",
        field: "detailDate",
        label: "Actual Delivery Date",
        dateRule: "pastOrToday",
        displayLabel: "Actual Delivery",
      },
    },
  ],
  INSTALLATION: [
    {
      value: "Installer/Contractor",
      label: "Installer/Contractor",
      progressPercent: 25,
      nextAction: "Start Installation",
      detail: {
        type: "text",
        field: "detailText",
        label: "Installer/Contractor",
      },
    },
    {
      value: "started",
      label: "Started",
      progressPercent: 50,
      nextAction: "Complete Testing",
    },
    {
      value: "Tested",
      label: "Tested",
      progressPercent: 75,
      nextAction: "Complete Sign Off",
    },
    {
      value: "Signed Off",
      label: "Signed Off",
      progressPercent: 100,
      nextAction: "Start Commissioning",
    },
  ],
  COMMISSIONING: [
    {
      value: "Commissioning Completed",
      label: "Commissioning Completed",
      progressPercent: 25,
      nextAction: "None. Logistics complete",
    },

  ],
  NOT_STARTED: [
    {
      value: "Awaiting Kickoff",
      label: "Awaiting Kickoff",
      progressPercent: 0,
      nextAction: "Issue IDR",
    },
  ],
};

export const LOGISTICS_STAGE_UPDATE_OPTIONS = LOGISTICS_STAGE_KEYS.map(
  (stageKey) => ({
    value: stageKey,
    label: getLogisticsStageConfig(stageKey).label,
  }),
);

const normalizeLookupValue = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "");

const resolveLogisticsStageKey = (stageKey) => {
  const normalizedStageKey = normalizeLookupValue(stageKey);

  return Object.keys(LOGISTICS_MILESTONE_OPTIONS).find(
    (key) => normalizeLookupValue(key) === normalizedStageKey,
  );
};

export const getLogisticsMilestoneOptions = (stageKey) => {
  const resolvedStageKey = resolveLogisticsStageKey(stageKey);

  return resolvedStageKey ? LOGISTICS_MILESTONE_OPTIONS[resolvedStageKey] : [];
};

export const getLogisticsMilestoneOption = (stageKey, milestone) =>
  getLogisticsMilestoneOptions(stageKey).find(
    (option) =>
      normalizeLookupValue(option.value) === normalizeLookupValue(milestone) ||
      normalizeLookupValue(option.label) === normalizeLookupValue(milestone),
  );

export const getLogisticsMilestoneProgressPercent = (stageKey, milestone) =>
  getLogisticsMilestoneOption(stageKey, milestone)?.progressPercent ?? 0;
